import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, ClockIcon, LockIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function OfferSection() {
  const cartUrl = 'https://competirsinmiedo.com/cart/add?id=45092891263029&quantity=1';
  return <section className="py-16 md:py-24 bg-brand-cream-dark relative overflow-hidden" id="offer" data-id="element-99">
      {/* Decorative background - hidden on mobile for performance */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-brand-amber/5 rounded-full blur-3xl hidden md:block" data-id="element-100"></div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-101">
        <div className="bg-white rounded-3xl shadow-2xl overflow-hidden border border-brand-slate/10" data-id="element-102">
          <div className="grid grid-cols-1 lg:grid-cols-2" data-id="element-103">
            {/* Left side: Product Visual */}
            <div className="bg-brand-green p-10 flex flex-col items-center justify-center relative overflow-hidden" data-id="element-104">
              <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1518605368461-1e1e111e1ebc?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80')] bg-cover bg-center opacity-10 mix-blend-overlay" data-id="element-105"></div>

              <motion.div initial={{
              scale: 0.9,
              opacity: 0
            }} whileInView={{
              scale: 1,
              opacity: 1
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5
            }} className="relative z-10 w-full max-w-xs" data-id="element-106">
                {/* Book Cover Image */}
                <div className="relative aspect-[3/4] w-full" data-id="element-107">
                  <img src="https://cdn.magicpatterns.com/uploads/kPXLbtysZ3qg94JkWcaGFV/WhatsApp_Image_2026-03-31_at_00.12.25.jpg" alt="Competir Sin Miedo - Guía + 9 Bonos" className="w-full h-full object-cover rounded-xl shadow-2xl" loading="lazy" data-id="element-108" />
                </div>
              </motion.div>

              <div className="mt-10 text-center relative z-10" data-id="element-109">
                <div className="inline-flex items-center justify-center px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full text-white text-sm font-medium border border-white/20" data-id="element-110">
                  <ClockIcon className="w-4 h-4 mr-2 text-brand-amber" data-id="element-111" />
                  Acceso digital inmediato
                </div>
              </div>
            </div>

            {/* Right side: Checkout Info */}
            <div className="p-6 md:p-12 flex flex-col justify-center" data-id="element-112">
              <div className="inline-block bg-red-100 text-red-700 font-bold px-3 py-1 rounded-full text-sm mb-6 w-max border border-red-200" data-id="element-113">
                70% DE DESCUENTO
              </div>

              <h2 className="text-3xl md:text-4xl font-heading text-brand-slate mb-2" data-id="element-114">
                Acceso Completo
              </h2>
              <p className="text-brand-slate-light mb-4" data-id="element-115">
                Recibe un método claro, herramientas aplicables y bonos pensados
                para acompañar el proceso completo hoy.
              </p>
              <p className="text-red-600 font-bold text-lg uppercase mb-8" data-id="element-116">
                ¡AYÚDALO ANTES DE SU PRÓXIMO JUEGO!
              </p>

              <div className="flex items-end gap-4 mb-2" data-id="element-117">
                <span className="text-5xl md:text-6xl font-heading text-brand-slate leading-none" data-id="element-118">
                  €17.99
                </span>
                <span className="text-2xl text-brand-slate-light line-through mb-1" data-id="element-119">
                  €118.00
                </span>
              </div>

              <p className="text-xs text-brand-slate-light mb-6" data-id="element-120">
                Pago seguro. Acceso inmediato tras la compra.
              </p>

              <a href={cartUrl} onClick={trackAddToCart} className="w-full flex justify-center items-center px-8 py-5 text-xl font-bold text-white bg-brand-amber hover:bg-brand-amber-light rounded-xl shadow-lg hover:shadow-glow transition-all duration-300 transform hover:-translate-y-1 mb-6 text-center" data-id="element-121">
                Acceder Ahora por Solo €17.99 →
              </a>
              <p className="font-medium text-sm tracking-wide text-center -mt-3 mb-3 text-[#334155]" data-id="element-122">
                La confianza de tu hijo empieza con este clic
              </p>

              <div className="space-y-4" data-id="element-123">
                <div className="flex items-center justify-center gap-2 text-sm text-brand-slate-light" data-id="element-124">
                  <LockIcon className="w-4 h-4 text-green-600" data-id="element-125" />
                  <span data-id="element-126">Pago 100% seguro y encriptado</span>
                </div>

                {/* Fake payment logos */}
                <div className="flex justify-center gap-3 opacity-60" data-id="element-127">
                  <div className="w-10 h-6 bg-brand-slate/10 rounded flex items-center justify-center text-[10px] font-bold" data-id="element-128">
                    VISA
                  </div>
                  <div className="w-10 h-6 bg-brand-slate/10 rounded flex items-center justify-center text-[10px] font-bold" data-id="element-129">
                    MC
                  </div>
                  <div className="w-10 h-6 bg-brand-slate/10 rounded flex items-center justify-center text-[10px] font-bold" data-id="element-130">
                    AMEX
                  </div>
                  <div className="w-10 h-6 bg-brand-slate/10 rounded flex items-center justify-center text-[10px] font-bold" data-id="element-131">
                    PAYPAL
                  </div>
                </div>
              </div>

              <div className="mt-8 pt-6 border-t border-brand-slate/10 flex items-start gap-4" data-id="element-132">
                <ShieldCheckIcon className="w-10 h-10 text-brand-green flex-shrink-0" data-id="element-133" />
                <div data-id="element-134">
                  <h4 className="font-bold text-brand-slate" data-id="element-135">
                    Garantía de Satisfacción
                  </h4>
                  <p className="text-sm text-brand-slate-light mt-1" data-id="element-136">
                    Tu compra está 100% respaldada. Si el material no te ayuda,
                    te devolvemos tu dinero.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}